import { render, staticRenderFns } from "./SettingsExchangeRates.vue?vue&type=template&id=81266b56&scoped=true&"
import script from "./SettingsExchangeRates.vue?vue&type=script&lang=js&"
export * from "./SettingsExchangeRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81266b56",
  null
  
)

export default component.exports